// Tariff/TariffDetail.tsx

import React, {useEffect} from 'react';
import {useTheme} from 'Theme/ThemeContext';
import Button from 'Core/components/elements/Button/Button';
import {ITariff} from '../../Types/psychology/tariff';
import {FC, FR} from 'WideLayout/Layouts';
import {Link, useNavigate} from 'react-router-dom';

interface TariffDetailProps {
    tariff: ITariff;
    cls?: string;
}

const TariffDetail: React.FC<TariffDetailProps> = ({tariff, cls}) => {
    const {plt} = useTheme();
    const navigate = useNavigate();

    const price = parseInt(String(tariff.prices[0]?.amount || 0));
    const currency = tariff.prices[0]?.currency || '';
    const handleBuy = () => {
        navigate(`/order/tariff/${tariff.id}`, {state: {product: tariff}});
    };

    useEffect(() => {
        console.log('Tariff products:', tariff.products);
        tariff.products.forEach(product => {
            console.log('Product:', product);
        });
    }, [tariff.products]);

    const renderProduct = (product: any) => {
        // умность
        const linkStyle = {
            color: 'black',
            fontWeight: (product.polymorphic_ctype.model === 'psychologyguide' ||
                product.polymorphic_ctype.model === 'course') ? 'bold' : 'normal',
            cursor: (product.polymorphic_ctype.model === 'psychologyguide' ||
                product.polymorphic_ctype.model === 'course') ? 'pointer' : 'default',
            textDecoration: 'none'
        };

        if (product.polymorphic_ctype.model === 'psychologyguide') {
            return <Link to={`/guide/${product.id}`} style={linkStyle}>{product.name}</Link>;
        }
        if (product.polymorphic_ctype.model === 'course') {
            return <Link to={`/course/${product.id}`} style={linkStyle}>{product.name}</Link>;
        }
        return <span style={{color: 'black'}}>{product.name}</span>;
    };

    return (
        <FC cls={`tariff-detail ${cls}`} g={1} maxW={700}>
            <h2>{tariff.name}</h2>
            <FR sx={{whiteSpace: 'pre-wrap'}} color={plt.text.primary50}>{tariff.description}</FR>
            <ul>
                {tariff.products.map((product) => (
                    <li key={product.id}>{renderProduct(product)}</li>
                ))}
            </ul>
            <Button
                className={'mt-2 maxw-300px'}
                variant={'contained'}
                color={'primary'}
                onClick={handleBuy}
            >
                Купить за {price} {currency}
            </Button>
        </FC>
    );
};

export default TariffDetail;
